const isWeb = true;
import { getSystemType } from '@nibfe/mkt-env-api';
import { SystemType } from '@nibfe/mkt-env-api/src/libs/enum';
let libs;
if (true)
    libs = require('@nibfe/mkt-libs');
export function debounce(fn, delay) {
    let timer = null;
    // 使用箭头函数保持 this 指向
    return (...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn(...args);
            timer = null;
        }, delay);
    };
}
export function getUTM() {
    try {
        const systemType = getSystemType();
        let utm_medium = systemType === SystemType.android ? 'android' : systemType === SystemType.harmony ? 'HarmonyOS' : 'iphone';
        if (isWeb && libs) {
            const { env } = libs;
            if (env.miniProgram.isMiniProgram()) {
                utm_medium = 'WEIXINPROGRAM';
            }
        }
        return utm_medium;
    }
    catch (e) {
        return 'iphone';
    }
}
